import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

export type SlurryInfoFooterBlockedScope = 'infoFooter';

export interface SlurryInfoFooterBlockedActionClick {
  reason: string;
  scope: SlurryInfoFooterBlockedScope;
}

@Component({
  selector: 'app-slurry-info-footer-actions',
  standalone: true,
  imports: [CommonModule, MatTooltipModule],
  templateUrl: './slurry-info-footer-actions.component.html'
})
export class SlurryInfoFooterActionsComponent {
  @Input() isParentProjectCompleted = false;
  @Input() hasSavedSlurry = false;
  @Input() showUpdate = false;
  @Input() showSendToLab = false;
  @Input() showRevert = false;
  @Input() showAddSingleTest = false;
  @Input() showComplete = false;
  @Input() updateBlockedReason = '';
  @Input() sendToLabBlockedReason = '';
  @Input() revertBlockedReason = '';
  @Input() addSingleTestBlockedReason = '';
  @Input() createBlockedReason = '';
  @Input() completeBlockedReason = '';
  @Input() blockedInfoFooterActionMessage = '';
  @Input() saveMessage = '';
  @Input() isSaving = false;

  @Output() updateRequested = new EventEmitter<void>();
  @Output() sendToLabRequested = new EventEmitter<void>();
  @Output() revertRequested = new EventEmitter<void>();
  @Output() addSingleTestRequested = new EventEmitter<void>();
  @Output() createRequested = new EventEmitter<void>();
  @Output() completeRequested = new EventEmitter<void>();
  @Output() blockedActionClicked = new EventEmitter<SlurryInfoFooterBlockedActionClick>();

  onBlockedActionClick(reason: string): void {
    this.blockedActionClicked.emit({ reason, scope: 'infoFooter' });
  }
}
